/**
 * poppet.Model
 * An extended Backbone Model.
 * @version 0.8.0
 */
const Model = Bb.Model.extend({

	// ------------------------------------------------
	// Setup
	// ------------------------------------------------

	completeList: [],

	// ------------------------------------------------
	// Event handlers
	// ------------------------------------------------

	/**
	 * @constructor
	 */
	initialize: function (options) {
		this.options = options || {};

		this.listenTo(this, 'error', this.onError);

		Bb.Model.prototype.initialize.call(this, this.options);
	},

	/**
	 * Reverts model attributes on error
	 * @void
	 */
	onError: function () {
		this.set(this._previousAttributes);
	},

	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Verifies that every attribute listen in this.completeName are truthy, otherwize returns false.
	 * @return {bool} True if this Model is complete, false if not.
	 */
	isComplete: function () {

		let complete = true;

		_.each(this.completeList, function (attribute) {
			if (!this.get(attribute)) {
				complete = false;
			}
		}, this);

		return complete;
	},

});

export default Model;
